import React, { useId } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ImageLink } from "../utils/constants";
import ActionPermission from "../Auth/ActionPermission";
const getFileType = (filePath = "") => {
  const lowerPath = filePath.toLowerCase();

  const imageFormats = [".jpg", ".jpeg", ".png", ".webp"];
  const videoFormats = [".mp4", ".webm", ".ogg"];

  if (videoFormats.some((ext) => lowerPath.endsWith(ext))) {
    return "video";
  }

  if (imageFormats.some((ext) => lowerPath.endsWith(ext))) {
    return "image";
  }

  return "unknown";
};
const checkImage = (item) => {
     if (!item) {
        return <p>-</p>;
    }
    const formatdata = getFileType(item);
    const imageUrl = encodeURI(ImageLink(item));
     if (formatdata === "image") {
        const isSvg = item?.toLowerCase()?.endsWith(".svg");
        return (
            <img
                src={imageUrl}
                alt=""
                style={{
                    height: "70px",
                    width: isSvg ? "70px" : "130px",
                    objectFit: "cover",
                    borderRadius: "5px",
                    objectPosition:"top center"
                }}
                className="lazy-load"
            />
        );
    } else if (formatdata === "video") {
        return <p>Video</p>;
    } else {
        return <p>-</p>;
    }
};

const ToggleSwitch = ({
 data,
 name,
 checked,
 handleStatusToggle,
 module,
 stockLoadingIds
}) => {

 const handleChange = () => {

   if(stockLoadingIds) return;

   handleStatusToggle(data);

 };


 return (
  <ActionPermission pageKey={module} action="Status">

   <div className="toggle-switch">

    <input
     type="checkbox"
     id={`toggleSwitch-${data?.id}-${name}`}
     checked={checked}
     onChange={handleChange}
    />

    <label
     htmlFor={`toggleSwitch-${data?.id}-${name}`}
     className="switch-label"
    >
     <span className="switch-inner" />
     <span className="switch-handle" />
    </label>

   </div>

  </ActionPermission>
 );
};
const StockCheckbox = ({
  data,
  checked,
  handleStockToggle,
}) => {
  const isDisabled = data?.outOfStock === true;

  const handleChange = () => {
    if (isDisabled) return;
    handleStockToggle(data);
  };

  return (
    <div className="toggle-switch stock-switch">
      <input
        type="checkbox"
        id={`stockSwitch-${data?.id}`}
        checked={checked}
        disabled={isDisabled}
        onChange={handleChange}
      />

      <label
        htmlFor={`stockSwitch-${data?.id}`}
        className={`switch-label ${isDisabled ? "disabled-switch" : ""}`}
      >
       <span className={`switch-text ${checked ? "out" : "in"}`}>
  {checked ? "OUT" : "IN"}
</span>

        <span className="switch-inner" />
        <span className="switch-handle" />
      </label>
    </div>
  );
};


const ActionButton = ({ data, handleEditClick, handleDelete, editicon = null, edittitle = null, module }) => {

    return (
        <div className="template-demo" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <ActionPermission pageKey={module} action="Update">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="edit-tooltip">{edittitle ? edittitle : 'Edit'}</Tooltip>}
                    >
                        <div style={{ background: "rgba(255, 108, 47, 0.1)", padding: "5px", borderRadius: "5px" }}>
                            <i
                                className={editicon ? editicon : "fa-solid fa-pen-to-square"}
                                style={{
                                    cursor: "pointer",
                                    color: editicon ? 'rgba(99, 221, 99, 1)' : "rgb(38, 94, 215)",
                                    padding: "5px",
                                    fontSize: "18px",
                                }}
                                onClick={() => handleEditClick(data)}
                            />
                        </div>
                    </OverlayTrigger>

                </ActionPermission>

           <ActionPermission pageKey={module} action="Delete">
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="delete-tooltip">Delete</Tooltip>}
                >
                    <div style={{ background: "rgba(255, 77, 107, 0.1)", padding: "5px", borderRadius: "5px" }}>
                        <i
                            className="fa-solid fa-trash-can"
                            onClick={() => handleDelete(data)}
                            style={{
                                cursor: "pointer",
                                color: "rgba(255, 77, 107, 1)",
                                padding: "5px",
                                fontSize: "18px",
                            }}
                        />
                    </div>
                </OverlayTrigger>
           </ActionPermission>
        </div>

    );
};
const PlusButton = ({ handleAdd, name = null, module }) => {
    return (
        <ActionPermission pageKey={module} action="Add">
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="plus-tooltip">Add {name}</Tooltip>}
        >
            <div
                onClick={handleAdd}
                style={{
                    height: "40px",
                    width: "40px",
                    background: "#656CD9",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "17px",
                    color: "#fff",
                    cursor: "pointer",
                }}
            >
                <i className="fa-solid fa-plus"></i>
            </div>
        </OverlayTrigger>
        </ActionPermission>
    );
};

const ViewButton = ({ handleRedirect, id }) => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="plus-tooltip">View</Tooltip>}
        >
            <div style={{ background: "rgba(255, 108, 47, 0.1)", padding: "3px", borderRadius: "5px",display:"flex",justifyContent:"center",alignItems:"center" }}>
                <i
                    className={"fa-regular fa-eye"}
                    style={{
                        cursor: "pointer",
                        color: "rgb(38, 94, 215)",
                        padding: "5px",
                        fontSize: "18px",
                    }}
                    onClick={(e) => handleRedirect(id)}
                />
            </div>
        </OverlayTrigger>
    );
};
const ExportExcell = ({ onClick, loading, size }) => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="export-tooltip">Export</Tooltip>}
        >
            <div
                onClick={!loading ? onClick : undefined}
                style={{
                    height: size ? "30px" : "40px",
                    width: size ? "30px" : "40px",
                    background: "#012711f1",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: size ? "16px" : "21px",
                    color: "#fff",
                    cursor: loading ? "not-allowed" : "pointer",
                }}
            >
                {loading ? (
                    <i className="fa-solid fa-spinner fa-spin"></i>
                ) : (
                    <i className="fa-solid fa-file-arrow-up"></i>
                )}
            </div>
        </OverlayTrigger>
    );
};
const ImportExcell = ({ handleAdd }) => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="plus-tooltip">Import </Tooltip>}
        >
            <div
                onClick={handleAdd}
                style={{
                    height: "40px",
                    width: "40px",
                    background: "#1f6846ff",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "21px",
                    color: "#fff",
                    cursor: "pointer",
                }}
            >
                <i className="fa-solid fa-file-arrow-down"></i>
            </div>
        </OverlayTrigger>
    );
};
const DeleteButton = ({ handleAdd, name = null, module }) => {
    return (
        <ActionPermission pageKey={module} action="Bulk Delete">
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="plus-tooltip">Delete {name}</Tooltip>}
        >
            <div
                onClick={handleAdd}
                style={{
                    height: "40px",
                    width: "40px",
                    background: "rgb(255, 77, 107)",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "17px",
                    color: "#fff",
                    cursor: "pointer",
                }}
            >
                <i className="fa-solid fa-trash-can"></i>
            </div>
        </OverlayTrigger>
        </ActionPermission>
    );
};
const ColumnAdjust = ({ handleOpen, name = null, sidebarred }) => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="plus-tooltip">{name} Column Unlock</Tooltip>}
        >
            <div
                ref={sidebarred}
                onClick={handleOpen}
                style={{
                    height: "40px",
                    width: "40px",
                    background: "rgb(255, 77, 107)",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "17px",
                    color: "#fff",
                    cursor: "pointer",
                }}
            >
                <i className="fa-solid fa-sliders"></i>
            </div>
        </OverlayTrigger>
    );
};
const HandAdvancefilter = ({ handleAdd, name = null }) => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="plus-tooltip">Advance filter</Tooltip>}
        >
            <div
                onClick={handleAdd}
                style={{
                    height: "40px",
                    width: "40px",
                    background: "#ff8787",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "17px",
                    color: "#fff",
                    cursor: "pointer",
                }}
            >
                <i className="fa-solid fa-filter"></i>
            </div>
        </OverlayTrigger>
    );
};
const SwitchToggle = ({ checked, onChange, name, id }) => {
    const autoId = useId();
    const toggleId = id || `switch-${name || autoId}`;

    return (
        <div
            className="d-flex align-items-center justify-content-between border border-dark p-3 rounded"
            style={{ gap: "1rem" }}
        >
            <div>
                <p className="m-0 fw-semibold">isActive?</p>
                <small className="text-muted">
                    {checked
                        ? "Turning ON isActive mode will show this."
                        : "Turning OFF isActive mode will hide this."}
                </small>
            </div>

            <div className="toggle-switch">
                <input
                    type="checkbox"
                    id={toggleId}
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    style={{ display: "none" }}
                />
                <label
                    htmlFor={toggleId}
                    className="switch-label"
                    style={{
                        display: "inline-block",
                        width: "45px",
                        height: "24px",
                         background: checked
      ? "linear-gradient(135deg, #222222, #555555)"
      : "#ccc",
                        borderRadius: "50px",
                        position: "relative",
                        cursor: "pointer",
                        transition: "background 0.3s",
                    }}
                >
                    <span
                        className="switch-handle"
                        style={{
                            position: "absolute",
                            top: "2px",
                            left: checked ? "24px" : "2px",
                            width: "20px",
                            height: "20px",
                            background: "#fff",
                            borderRadius: "50%",
                            transition: "left 0.3s",
                            boxShadow: "0 0 3px rgba(0,0,0,0.3)",
                        }}
                    />
                </label>
            </div>
        </div>
    );
};
const Back = ({ handleBack, }) => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="plus-tooltip">Go Back</Tooltip>}
        >
            <div
                onClick={handleBack}
                style={{
                    height: "40px",
                    width: "40px",
                    background: "linear-gradient(135deg, #101011ff, #8f4141ff)", borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "17px",
                    color: "#fff",
                    cursor: "pointer",
                }}
            >
                <i class="fa-solid fa-outdent"></i>
            </div>
        </OverlayTrigger>
    );
};

const DeleteSingleButton = ({ handleDelete, item }) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`view-tooltip-${item._id}`}>Delete</Tooltip>}
    >
      <div
        onClick={() => handleDelete(item)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          background: "rgba(255, 77, 107, 0.1)",
          borderRadius: "8px",
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(255, 108, 47, 0.2)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(255, 108, 47, 0.1)";
        }}
      >
        <i
                        className="fa-solid fa-trash-can"
                        size={30}
                        style={{
                            cursor: "pointer",
                            color: "rgba(255, 77, 107, 1)",
                            padding: "5px",
                        }}
                    />
      </div>
    </OverlayTrigger>
  );
};
export default getFileType;
export {
    checkImage,
    ToggleSwitch,
    ActionButton,
    PlusButton,
    ImportExcell,
    ExportExcell,
    DeleteButton,
    ColumnAdjust,
    ViewButton,
    SwitchToggle,
    HandAdvancefilter,
    Back,
    DeleteSingleButton,
    StockCheckbox
};
